/*
 * @Author: pingping.mao
 * @Date: 2022-04-20 14:17:21
 * @LastEditTime: 2022-08-03 11:18:54
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/globals.js
 */
import Vue from "vue";


/**
 * @Description 通用工具库
 */
import utils from "./utils/index";
Vue.prototype.$utils = utils;

import http from "./utils/request";
Vue.prototype.$http = http;

/**
 * @Description 乾坤,微前端解决方案
 */
import { initGlobalState } from "qiankun";
const actions = initGlobalState({
  mt: "init", // 初始化state，里面内容您随意
  excelRecord: { show: false, type: "import" },
  notify: { attachment: false }
});
// 在项目中任何需要监听的地方进行监听，在这里监听是为了方便
actions.onGlobalStateChange((state, prev) => {
  // console.log("main state change", state);
});
// 将action对象绑到Vue原型上，为了项目中其他地方使用方便
Vue.prototype.$actions = actions;

/**
 * @Description Day.js是一个极简的JavaScript库，可以为现代浏览器解析、验证、操作和显示日期和时间。
 */
import dayjs from "dayjs";
Vue.prototype.dayjs = dayjs;

/**
 * @Description 引入按钮权限
 */
import { checkPermission, checkOrgPermission } from "@/utils/permission";
Vue.prototype.checkPermission = checkPermission;
/**
 * @Description 引入组织权限
 */
Vue.prototype.checkOrgPermission = checkOrgPermission;
